import { useSelector } from 'react-redux'
import { getPageParams } from 'selectors/page'
import { UseReduxSearchProviderResponse } from '../types'
import {
  getPathParams,
  getSearchProviderBasicQueryParam,
  getSelectedFacets,
  getSharedFacetNames,
  getSearchProviderArtworks,
  getSearchProviderFacets,
  getSearchProviderSort,
} from 'selectors/searchProvider'
import useUpdatedSearchProviderRedux from './useUpdatedSearchProviderRedux'
import { getMeasurementUnit } from 'selectors/user/session'
import {
  getSelectedFacetsSizeMinMax,
  getSelectedSize,
} from 'selectors/searchProviderFacets/sizeFacet'
import { getSelectedFacetsPriceMinMax } from 'selectors/searchProviderFacets/priceFacet'

const useReduxSearchProvider = (): UseReduxSearchProviderResponse => {
  const { updateSearchProviderStore } = useUpdatedSearchProviderRedux()

  const selectedFacets = useSelector(getSelectedFacets)
  const basicQueryParams = useSelector(getSearchProviderBasicQueryParam)
  const pathParams = useSelector(getPathParams)
  const sharedFacetNames = useSelector(getSharedFacetNames)
  const pageParams = useSelector(getPageParams)
  const artworksResults = useSelector(getSearchProviderArtworks)
  const facetsFromSearchProvider = useSelector(getSearchProviderFacets)
  const sort = useSelector(getSearchProviderSort)
  const measurementUnit = useSelector(getMeasurementUnit)
  const selectedSize = useSelector(getSelectedSize)
  const sizeMinMax = useSelector(getSelectedFacetsSizeMinMax)
  const priceMinMax = useSelector(getSelectedFacetsPriceMinMax)

  return {
    selectedFacets,
    basicQueryParams,
    pathParams,
    sharedFacetNames,
    pageParams,
    artworksResults,
    facetsFromSearchProvider,
    sort,
    updateReduxStore: updateSearchProviderStore,
    measurementUnit,
    selectedSize,
    sizeMinMax,
    priceMinMax,
  }
}

export default useReduxSearchProvider
